import React, { Suspense } from 'react'
import Footer from 'components/molecules/Footer'
import Header from 'components/molecules/Header'
import { Spin } from 'antd'
import { Icon404 } from 'assets'
import SmartLink from 'components/atoms/SmartLink'

function NotFound() {
  return (
    <div className="min-h-screen md:h-screen relative flex-col flex justify-between">
      <Header />
      <Suspense
        fallback={
          <div
            className="
        flex justify-center items-center flex-col min-h-0 flex-grow">
            <Spin size="large" spinning={true}></Spin>
          </div>
        }>
        <div className={'wrapper-title flex flex-col gap-[4px] items-center my-10'}>
          <div>
            <Icon404 />
          </div>
          <p className={'text-2xl font-bold text-neutral-900 text-left sm:text-center'}>
            Halaman tidak ditemukan
          </p>
          <p className={'text-xl font-normal text-neutral-500 text-center'}>
            Mohon maaf, kami tidak dapat mencari halaman yang anda tuju.
          </p>

          <SmartLink
            isNextUrl={true}
            href={'/'}
            className="pt-10 text-primary hover:text-secondary no-underline">
            Back to main page
          </SmartLink>
        </div>
      </Suspense>
      <Footer />
    </div>
  )
}

export default NotFound
